/**
 * Identifies the form of delivery.
 * tag: 668
 * @readonly
 * @enum {number} (int)
 */
export enum DeliveryForm {
  /** Book Entry (default) */
  BookEntry = 1,
  /** Bearer */
  Bearer = 2,
}
